/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { UserService } from '../../../../@core/data/user.service';
import { HttpClient } from '@angular/common/http';
import { ProjectsService } from '../../../../@core/data/projects.service';
import { LogoService } from '../../../../@core/services/logo.service';


@Component({
  selector: 'ngx-logout',
  template: `
    <div class="text-center title mb-5">
      <img class="img-fluid" src={{logo}} alt="Logo">
    </div>
    <h3 class="text-center">Estás saliendo del sistema, espera...</h3>
  `,
})
export class NgxLogoutComponent implements OnInit {
  logo: string;
  redirectDelay = 1500;

  constructor(
    protected service: NbAuthService,
    protected router: Router,
    private userService: UserService,
    private http: HttpClient,
    private projectsService: ProjectsService,
    private logoService: LogoService,
  ) {
    this.logoService.getLogo().subscribe(logo => {
      this.logo = logo;
    });
  }

  ngOnInit(): void {
    this.userService.logout().then(response => {
      if (response) {
        this.logout('email');
        localStorage.clear();
        sessionStorage.clear();
      } else {
        throw new Error('Something went terribly wrong');
      }
    });
  }

  clearLocalStorage() {
    localStorage.removeItem('map');
    localStorage.removeItem('searchMap');
    localStorage.removeItem('projects');
    localStorage.removeItem('search');
    localStorage.removeItem('searchTags');
    localStorage.removeItem('sort');
    localStorage.removeItem('sortDirection');
    localStorage.removeItem('pageIndex');
    localStorage.removeItem('tab_actual');
    localStorage.removeItem('orderName');
    localStorage.removeItem('orderBy');
  }

  logout(provider: string): void {
    this.projectsService.clearProjects();
    this.service.logout(provider).subscribe((result: NbAuthResult) => {
      this.clearLocalStorage();
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
    });
  }
}
